import { defineStore } from "pinia";
import { useLocaleStore } from "./useLocaleStore";
import { useDialogStore } from "./useDialogStore";
import type { Position, Sizing, TimerDurations } from "@/types";

interface UserPreferencesState {
  orderBubblesAsPlayer: boolean;
  orderBubblesAsHost: boolean;
  hideGrim: boolean;
  hideOutOfPlay: boolean;
  isMenuOpen: boolean;
  isStatic: boolean;
  isMuted: boolean;
  isImageOptIn: boolean;
  isStreamerMode: boolean;
  zoom: number;
  background: string;
  notes: {
    content: string;
    opened: boolean;
    hidden: boolean;
    position: Position;
    sizing: Sizing;
  };
  chat: {
    position: Position;
  };
  voiceChat: {
    opened: boolean;
    position: Position;
  };
  timerDurations: TimerDurations;
  discordName: string;
}

export const useUserPreferencesStore = defineStore("userPreferences", {
  actions: {
    async setDiscordName() {
      const localeStore = useLocaleStore();
      const dialogStore = useDialogStore();
      const t = localeStore.t;
      this.discordName = await dialogStore.prompt(t("prompt.setDiscordName"), this.discordName) || "";
    },
  },
  state: (): UserPreferencesState => ({
    orderBubblesAsPlayer: false,
    orderBubblesAsHost: true,
    hideGrim: false,
    hideOutOfPlay: false,
    isMenuOpen: false,
    isStatic: false,
    isMuted: false,
    isImageOptIn: false,
    isStreamerMode: false,
    zoom: 0,
    background: "",
    notes: {
      content: "",
      opened: false,
      hidden: false,
      position: {
        x: 10,
        y: 100,
      },
      sizing: {
        width: 400,
        height: 300,
      }
    },
    chat: {
      position: {
        x: 10,
        y: 250,
      }
    },
    voiceChat: {
      opened: false,
      position: {
        x: 10,
        y: 400,
      }
    },
    timerDurations: {
      daytime: 6,
      nominations: 2,
      dusk: 1,
      accusation: 0.5,
      defense: 0.5,
      debate: 1,
      custom: 1,
      customDebate: 1,
    },
    discordName: "",
  }),
  persist: true,
});
